import { Component, ViewEncapsulation } from "@angular/core";
import {IFloatingFilterAngularComp} from "ag-grid-angular";
import { FilterChangedEvent, IFloatingFilterParams } from "ag-grid-community";
import { ISelectOption } from "../shared/models/option";

@Component({
  selector: "pps-employee-floating-filter",
  templateUrl: "./employee-floating-filter.component.html",
  styles: [`
    pps-employee-floating-filter{
      width:100%;
    }

    /*without this, the filter input field will be vertically aligned to top*/
    pps-employee-floating-filter .ag-floating-filter-input{
      height: 100%;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeFloatingFilterComponent implements IFloatingFilterAngularComp{
  params!: IFloatingFilterParams<any>;
  employeeName: string = null;
  selectedEmployees: ISelectOption[] = [];


  onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent): void {
    this.employeeName = null;
  }

  agInit(params: IFloatingFilterParams<any>): void {
    this.params = params;
  }

  onFilterChanged(evt){
    console.log(this.employeeName);
    
    if (!this.employeeName) {
      // Remove the filter
      this.params.parentFilterInstance((instance) => {
        instance.onFloatingFilterChanged(null);
      });
      return;
    }

    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged(this.employeeName);
    });    
  }
}